
      <svg id="bellCurve" #bellCurve width="100%" height="90%" viewBox="0 0 250 140" xmlns="http://www.w3.org/2000/svg" class="pointer p-3" >
        <path id="bellCurvePath" [attr.d]="pathData" stroke="#aaaaaa" fill="none"></path>
        <line
        x1="107" y1="10"
        x2="107" y2="115"
        stroke="#dddddd"
        stroke-width="1"
        stroke-dasharray="1,3"></line>
        <line
        x1="7" y1="115"
        x2="207" y2="115"
        stroke = "#dddddd"
        stroke-width="1"></line>

        <defs>
          <filter id="drop-shadow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur in="SourceAlpha" stdDeviation="0.5" />
              <feOffset dx="0" dy="0" result="offsetblur" />
              <feFlood flood-color="rgba(0,0,0,0.5)" />
              <feComposite in2="offsetblur" operator="in" />
              <feMerge>
                  <feMergeNode />
                  <feMergeNode in="SourceGraphic" />
              </feMerge>
          </filter>
      </defs>
      <circle
          *ngFor="let point of points"
          [attr.cx]="point.x"
          [attr.cy]="point.y"
          [attr.r]="circleRadius"
          [attr.fill]="point.color"
          [attr.filter]="'url(#drop-shadow)'"
          (pointerdown)="startDrag($event, point)">
      </circle>

        <text
          *ngFor="let point of points"
          [attr.x]="point.x + 8"
          [attr.y]="point.y + 2"
          font-size="8"
          fill="#000">
          {{ point.progress }}%
          {{ point.label }}
        </text>
        <text [attr.x]="10" [attr.y]="130" font-size="8" fill="#aaaaaa">
          Figuring things out
        </text>
        <text [attr.x]="120" [attr.y]="130" font-size="8" fill="#aaaaaa">
          Making things happen
        </text>
      </svg>
  